module.exports = __webpack_public_path__ + "img/lens-174-minus-10.58536cd8.png";